import { TrackEventData } from "common/appInsights/types/TrackEventData";

export enum TypeKeys {
    TRACK_EVENT = "TRACKING/TRACK_EVENT",
}

export const createAction = {
    track: (trackingData?: TrackEventData) => ({ type: TypeKeys.TRACK_EVENT, trackingData }),
};
